import { useSelector } from 'react-redux';
import FieldAgrilyticsContainer from './FieldAgrilyticsContainer';
import ScopedFieldAgrilytics from './ScopedFieldAgrilytics';
import { selectors } from '../../store/dux/field-agrilytics-dux';
import { Section } from '../Section';

export default function FieldAgrilytics() {
  const mapScopes = useSelector(selectors.mapScopes);
  const comparisonScopes = Object.keys(mapScopes).filter(
    (scope) => scope !== 'default',
  );

  return (
    <Section>
      <FieldAgrilyticsContainer>
        <ScopedFieldAgrilytics key="default-scope" />
        {comparisonScopes.map((scope) => (
          <ScopedFieldAgrilytics mapScope={scope} key={`${scope}-scope`} />
        ))}
      </FieldAgrilyticsContainer>
    </Section>
  );
}
